import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticatingController } from '../../../../common/js/AuthenticatingController';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { LoginType } from '../../classes/LoginType';

@Injectable()
export abstract class AuthenticationService {
  protected constructor(
    protected windowService: WindowService,
    protected route: ActivatedRoute,
    protected router: Router
  ) {}

  protected getController(): AuthenticatingController {
    return this.windowService.nativeWindow.controller;
  }

  public isLoggedIn(): boolean {
    return this.getController().loggedIn;
  }

  // when you keep your ex on the back burner just in case
  public goToAuthenticate(): void {
    this.goToRegister();
  }

  public abstract goToLogin(): Promise<void>;

  public abstract goToRegister(): Promise<void>;

  public abstract login(loginType?: LoginType): Promise<void>;

  public abstract logout(): Promise<void>;

  public async preLogout(): Promise<void> {}

  public routeAfterLogout(): void {
    this.router.navigate(['']);
  }

  public abstract changeEmail(email: string, password: string): Promise<void>;

  public abstract loginWithNewEmail(email: string, password: string): Promise<void>;

  public abstract resendVerificationEmail(): Promise<void>;

  protected abstract navigateOnError(): Promise<void>;

  public abstract resetPassword(url: string): Promise<string>;
}
